import { IGetEntregaObraGraficoUseCase } from "../../../presentation/useCases/read/get_entrega_obra_grafico_use_case";
import { EntregaObraGrafico } from "../../models/entrega_obra_cliente_grafico";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetEntregaObraGraficoUseCase
 */

export class GetEntregaObraGraficoUseCase implements IGetEntregaObraGraficoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(idEntregaObra: number): Promise<EntregaObraGrafico> {
    return this.repository.getEntregaObraGrafico(idEntregaObra);
  }
}
